import contract_creatives_registrar from "dictionaries/contract_creatives_registrar.json";
import createOptions from "utils/createOptions";

export default createOptions(contract_creatives_registrar);
